import { Component, OnInit, Input } from '@angular/core';
import { JPathService } from '@cv-invision/cv.component-library.ux';
import { Store } from '@ngxs/store';
import { merge } from 'lodash';
// States
import { QualityState } from '../../state/quality.state';
// Components

@Component({
	selector: 'cv-in-review-tables',
	templateUrl: './in-review-tables.component.html',
	styleUrls: ['./in-review-tables.component.scss']
})
export class InReviewTablesComponent implements OnInit {
	// @ViewChildren('fields') myFields: QueryList<ReviewFieldsComponent>;

	@Input() field: any;
	@Input() selectedType = '';
	@Input() selectedTargets: any;
	@Input() nested: any;

	document;
	schema;
	base;
	rows;

	constructor(
		private store: Store,
		private jPathService: JPathService
	) {
	}

	async ngOnInit(): Promise<void> {
		this.base = this.field.options.path;
		this.document = this.store.selectSnapshot(QualityState.getOrderDocument);
		this.schema = this.store.selectSnapshot(QualityState.geSchemaDocument);
		this.rows = this.jPathService.getValue(this.document, `$.${this.base}`);

		this.field.options.columns.forEach(column => {
			if (!('header' in column.options)) {
				const path = this.getSchemaPath(`${this.base}.${column.options.path}`);
				const header = this.jPathService.getValue(this.schema, `$.${path}.Metadata[0].DisplayText`);
				Object.assign(column.options, { header });
			}
		});
	}

	/**
	 * Return the schema path whithout index's
	 * @param path
	 */
	getSchemaPath(path: string): string {
		const pathPattern = /(\[[a-zA-z=0-9'\\]+\])/g;
		const schemaPath = path.replace(pathPattern, '');

		return schemaPath;
	}
}
